import { useState, useEffect } from 'react';
import { useTheme as useCustomTheme } from '../context/ThemeContext';

export const useHomeLogo = () => {
    const { activeThemeDefinition } = useCustomTheme();
    const [logoUrl, setLogoUrl] = useState<string>("");
  
    useEffect(() => {
        if (!activeThemeDefinition) return;
  
        if (activeThemeDefinition.assets?.logos && activeThemeDefinition.assets.logos.length > 0) {
            const logos = activeThemeDefinition.assets.logos;
            const randomLogo = logos[Math.floor(Math.random() * logos.length)];
            setLogoUrl(randomLogo.url);
        } else {
            setLogoUrl(""); 
        }
    }, [activeThemeDefinition]);

    return logoUrl;
};
